import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const CustomerTokenKey = 'Customer-Token'
const ProductLineTokenKey = 'Customer-Token-ProductLineGUID'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getCustomerToken () {
  return Cookies.get(CustomerTokenKey)
}

export function setCustomerToken (token) {
  return Cookies.set(CustomerTokenKey, token)
}

export function removeCustomerToken () {
  return Cookies.remove(CustomerTokenKey)
}

export function getProductLineToken () {
  return Cookies.get(ProductLineTokenKey)
}

export function setProductLineToken (token) {
  return Cookies.set(ProductLineTokenKey, token)
}

export function removeProductLineToken () {
  return Cookies.remove(ProductLineTokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js